import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import popi from "../../Assets/Projects/popi.png";
import billinglabs from "../../Assets/Projects/billinglabs.png";
import sequoya from "../../Assets/Projects/sequoya.png";


function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={popi}
              isBlog={false}
              title="POPI"
              description="Tool to create Orders and send them to suppliers for Adeo Productions."
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={sequoya}
              isBlog={false}
              title="Sequoya"
              description="SEQUOYA is an application common to several BU composed of different modules to list products and services, manage models structure, expose data to other applications."
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={billinglabs}
              isBlog={false}
              title="Billing Labs"
              description="BillingLabs is an enable massive, real-tim, ad-hoc billing with a full DevOps solution: cloud native, fully distributed and highly scalable"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
